import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Artists } from './pages/Artists';
import { Releases } from './pages/Releases';
import { Services } from './pages/Services';
import { Contact } from './pages/Contact';
import { DemoSubmission } from './pages/DemoSubmission';
import { CookiePolicy } from './pages/CookiePolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { LegalNotice } from './pages/LegalNotice';
import { CopyrightNotice } from './pages/CopyrightNotice';
import { PrivacyPolicy } from './pages/PrivacyPolicy';

import { Login } from './pages/admin/Login';
import { Dashboard } from './pages/admin/Dashboard';
import { AddArtist } from './pages/admin/AddArtist';
import { EditArtist } from './pages/admin/EditArtist';
import { AddRelease } from './pages/admin/AddRelease';
import { EditRelease } from './pages/admin/EditRelease';

const pageVariants = {
  initial: { opacity: 0 },
  in: { opacity: 1 },
  out: { opacity: 0 },
};

// FIX: Add 'as const' to ensure TypeScript infers literal types for framer-motion transition properties, resolving the type error.
const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.5,
} as const;

function App() {
  const location = useLocation();

  return (
    <Layout>
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial="initial"
          animate="in"
          exit="out"
          variants={pageVariants}
          transition={pageTransition}
          className="min-h-[60vh]"
        >
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/artists" element={<Artists />} />
            <Route path="/artists/:id" element={<Artists />} />
            <Route path="/releases" element={<Releases />} />
            <Route path="/releases/:id" element={<Releases />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/demo" element={<DemoSubmission />} />
            <Route path="/booking" element={<Artists initialView="booking" />} />
            
            {/* Legal Pages */}
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/legal-notice" element={<LegalNotice />} />
            <Route path="/copyright-notice" element={<CopyrightNotice />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/add-artist" element={<AddArtist />} />
            <Route path="/admin/edit-artist/:id" element={<EditArtist />} />
            <Route path="/admin/add-release" element={<AddRelease />} />
            <Route path="/admin/edit-release/:id" element={<EditRelease />} />

            {/* Fallback Route */}
            <Route path="*" element={<Home />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </Layout>
  );
}

export default App;
